<template>
    <span class="font-medium">Send an email</span>
</template>

<script>
export default {};
</script>
